import React from "react";
import { tableRowNavigation } from '../../helpers/TableRowNavigation';
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";
import {formattedPrice} from "../../helpers/MainHelper";

class CustomerServicesReportTable extends React.Component {
  handleServiceDetail = (serviceId) => {
    window.open(`${process.env.PUBLIC_URL}/service-detail/${serviceId}`, '_blank')
  }
  render() {
    const { bodyData } = this.props;
    return (

          <div className="table-responsive">
        <table className="table m-b-0 table-hover">
          <thead className="thead-light">
            <tr>
              <th>Servis ID</th>
              <th>Servis Tipi</th>
              <th>Plaka</th>
              <th>Marka/Model</th>
              <th>Durum</th>
              <th>Fiyat</th>

            </tr>
          </thead>
          <tbody>
            {bodyData && Object.keys(bodyData).length > 0 ?
              bodyData.map((data, i) => {
              return (
                <tr {...tableRowNavigation(() => this.handleServiceDetail(data.service_id))} key={"dihf" + i}>
                  <td>
                    <span className="badge badge-success">{data.service_id}</span>
                  </td>
                  <td className="project-title">
                    {data.type}
                  </td>
                  <td>
                    {data.plate.toUpperCase()}
                  </td>
                  <td>
                    {/*data.vehicle*/}
                  </td>
                  <td>
                    {data.status}
                  </td>
                  <td>
                    {formattedPrice(data.total)}
                  </td>
                </tr>
              );
            }
            ): (
                <tr>
                  <td colSpan="6">
                    <div className="alert alert-warning m-2 text-center">Lütfen Müşteri Seçiniz!</div>
                  </td>
                </tr>
                )}
          </tbody>
        </table>
          </div>

    );
  }
}

const mapStateToProps = ({mailInboxReducer}) => ({});

export default withRouter(connect(mapStateToProps, {})(CustomerServicesReportTable));
